module.exports = __webpack_public_path__ + "media/images/bank_images/real2-9acb57d88fb99b5ebf6be84a9026d437.png";